export function LegalAge(date: '^/d{2}/d{2}/d{4}$'): boolean {
  const birthDate = DateTime.fromFormat(date, 'dd/MM/yyyy');
  const today = DateTime.now();
  const age = Number.parseInt(today.diff(birthDate).as('years'));
  return age >= 18;
}
